import { j as json } from "../../../../chunks/index.js";
import { PrismaClient } from "@prisma/client";
const prisma = new PrismaClient();
const GET = async () => {
  const forms = await prisma.form.findMany();
  return json(forms);
};
export {
  GET
};
